export default __webpack_public_path__ + "static/pro-3-3daa3a5eb3515dea8e479ee44c90fd83.jpg";